/**
 * @generated SignedSource<<eaf1c907613d5b3111c81cdfa08d1561>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterOperator = "BEGINS_WITH" | "CONTAINS" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "NEQ" | "NOT_CONTAINS" | "%future added value";
export type OrderByDirection = "ASC" | "DESC" | "%future added value";
export type DrawingSetVersionListInput = {
  filter?: DrawingSetVersionListFilter | null | undefined;
  orderBy?: DrawingSetVersionListOrder | null | undefined;
};
export type DrawingSetVersionListFilter = {
  drawingSetId?: Filter | null | undefined;
  versionDate?: Filter | null | undefined;
};
export type Filter = {
  operator: FilterOperator;
  value: string;
};
export type DrawingSetVersionListOrder = {
  versionDate?: OrderByDirection | null | undefined;
};
export type getDrawingSetVersionListQuery$variables = {
  first?: number | null | undefined;
  input: DrawingSetVersionListInput;
};
export type getDrawingSetVersionListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"drawingSetVersionListFragment">;
};
export type getDrawingSetVersionListQuery = {
  response: getDrawingSetVersionListQuery$data;
  variables: getDrawingSetVersionListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "getDrawingSetVersionListQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "FragmentSpread",
        "name": "drawingSetVersionListFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "getDrawingSetVersionListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DrawingSetVersionConnection",
        "kind": "LinkedField",
        "name": "drawingSetVersionList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DrawingSetVersionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DrawingSetVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdById",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "versionDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "drawingSetId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "input"
        ],
        "handle": "connection",
        "key": "drawingSetVersionListFragment___drawingSetVersionList",
        "kind": "LinkedHandle",
        "name": "drawingSetVersionList"
      }
    ]
  },
  "params": {
    "cacheID": "d45623e01fae308955ee0388cf444e09",
    "id": null,
    "metadata": {},
    "name": "getDrawingSetVersionListQuery",
    "operationKind": "query",
    "text": "query getDrawingSetVersionListQuery(\n  $input: DrawingSetVersionListInput!\n  $first: Int\n) {\n  ...drawingSetVersionListFragment_1oNFuy\n}\n\nfragment drawingSetVersionFragment on DrawingSetVersion {\n  id\n  createdAt\n  updatedAt\n  createdById\n  fileName\n  versionDate\n  status\n  drawingSetId\n  jobId\n}\n\nfragment drawingSetVersionListConnectionFragment on DrawingSetVersionConnection {\n  edges {\n    cursor\n    node {\n      ...drawingSetVersionFragment\n      id\n    }\n  }\n  pageInfo {\n    ...pageInfoFragment\n  }\n}\n\nfragment drawingSetVersionListFragment_1oNFuy on Query {\n  drawingSetVersionList(input: $input, first: $first) {\n    edges {\n      cursor\n      node {\n        ...drawingSetVersionFragment\n        id\n        __typename\n      }\n    }\n    ...drawingSetVersionListConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment pageInfoFragment on PageInfo {\n  startCursor\n  endCursor\n  hasNextPage\n  hasPreviousPage\n}\n"
  }
};
})();

(node as any).hash = "0425830846f562f056c0e3a38105a35a";

export default node;
